module.exports = __webpack_public_path__ + "img/6-4.fed3705b.jpg";